import React from "react";

export default function ApplicantList() {
    return (
        <div>
            All Applicants List
        </div>
    )
}